import { useEffect, useRef } from 'react';
import useMeasure from 'react-use-measure';
import useLocationState from '../../hooks/useLocationState';

const ViewPort = props => {
    const [ref, { height, width }] = useMeasure();
    const { dispatch, state } = useLocationState();
    const h = useRef(0);
    const w = useRef(0);

    useEffect(() => {
        let r = Math.ceil(height);
        if (h.current !== r) {
            h.current = r;
            dispatch({ type: 'path-key-update', path: 'viewport', key: 'v', payload: h.current });
        }

        r = Math.ceil(width);
        if (w.current !== r) {
            w.current = r;
            dispatch({ type: 'path-key-update', path: 'viewport', key: 'w', payload: w.current });
        }

        return () => { dispatch({type: 'path-key-update', path:'viewport', key: 'v', payload: 0}); dispatch({type: 'path-key-update', path:'viewport', key: 'w', payload: 0}) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [height])

    return <div className="fixed-view-port" style={{top: state.viewport.m}}  ref={ref} >{props.children}</div>
}

export default ViewPort;